import { checkRole, matchPermission } from './utils/permission';
  import type { InitialState } from '@@/plugin-initial-state';

/**
 * 权限管理模块
 * @see https://umijs.org/zh-CN/plugins/plugin-access
 *
 * 该函数由 UmiJS Access 插件自动调用，返回的权限方法可用于：
 * 1. 组件内权限控制：useAccess().hasPerms('system:user:add')
 * 2. 路由级权限控制：authority: ['admin']
 * 3. 条件渲染：{access.canAdmin && <AdminButton />}
 */
export default function access(initialState: InitialState) {
  const { currentUser } = initialState || {};

  /**
   * 检查用户是否拥有指定权限点
   * @param perm - 权限标识，如 'system:user:add'
   * @returns true - 有权限，false - 无权限
   */
  const hasPerms = (perm: string): boolean => {
    return matchPermission(currentUser?.permissions, perm);
  };

  /**
   * 检查用户角色是否符合路由要求
   * @param route - 路由配置对象，包含 authority 数组
   * @returns true - 可访问，false - 不可访问
   */
  const roleFilter = (route: { authority: string[] }): boolean => {
    return checkRole(currentUser?.roles, route.authority);
  };

  return {
    /** 是否为管理员 */
    canAdmin: currentUser?.access === 'admin',
    /** 权限点检查函数 */
    hasPerms,
    /** 路由角色过滤函数 */
    roleFilter,
  };
}
